// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__globalContainer {
  /* min-width: 100vw; */
  min-height: 100vh;
  background: #eef0f8;
}

.globalContainer_For_Content {
  margin: 70px 0px 0px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".app__globalContainer {\n  /* min-width: 100vw; */\n  min-height: 100vh;\n  background: #eef0f8;\n}\n\n.globalContainer_For_Content {\n  margin: 70px 0px 0px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
